/** Max items shown per section when the field is empty (browse mode). */
export const TYPEAHEAD_BROWSE_LIMITS = {
  FREE_OPTIONS: 10,
  SYSTEM_OPTIONS: 10,
} as const;

export function isTypeaheadBrowseMode(searchQuery: string): boolean {
  return !searchQuery.trim();
}

function getBrowseSortLabel(
  option: Record<string, unknown>,
  getLabel?: (option: Record<string, unknown>) => string,
): string {
  if (getLabel) {
    const label = getLabel(option);
    if (label?.trim()) return label.trim();
  }

  return (
    (option.snomedFSN as string) ||
    (option.display as string) ||
    (option.medicineName as string) ||
    (option.text as string) ||
    (option.value as string) ||
    ""
  ).trim();
}

export function sortFreeOptionsByLabel<T>(
  freeOptions: T[],
  getLabel?: (option: Record<string, unknown>) => string,
): T[] {
  return [...freeOptions].sort((a, b) =>
    getBrowseSortLabel(a as Record<string, unknown>, getLabel).localeCompare(
      getBrowseSortLabel(b as Record<string, unknown>, getLabel),
      undefined,
      { sensitivity: "base" },
    ),
  );
}

export function limitBrowseFreeOptions<T>(
  freeOptions: T[],
  getLabel: ((option: Record<string, unknown>) => string) | undefined,
  limit: number,
): T[] {
  return sortFreeOptionsByLabel(freeOptions, getLabel).slice(0, limit);
}
